import { ChartDataPoint } from '@/api/admin/types';

export type CardProps = {
  title: string;
  value?: string | number;
  delta?: string;
  dollarAmount: boolean;
  isComingSoon: boolean;
  type?: 'line' | 'bar';
  strokeColor?: string;
  chartData?: ChartDataPoint[];
};

export const investorsUserChartCards: CardProps[] = [
  {
    title: 'New investors',
    value: '0',
    delta: '~0 investors/day',
    dollarAmount: false,
    isComingSoon: false,
    type: 'bar',
  },
  {
    title: 'Current total investors',
    value: '0',
    delta: '~0 investors/30 days',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Current total investor value',
    value: '$0',
    delta: '~$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Current average per investor',
    value: '$0',
    delta: '~$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Total number of new investments',
    value: '0',
    delta: '~0 investments/day',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Total value of new investments',
    value: '$0',
    delta: '~$0/day',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Total investments to date',
    value: '0',
    delta: '+0/30 days',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
  },
  {
    title: 'Current cumulative value',
    value: '$0',
    delta: '+$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
  },
];

export type UserCardId =
  | 'newUsers'
  | 'totalUsers'
  | 'newVerifiedUsers'
  | 'totalVerifiedUsers'
  | 'totalUserValue'
  | 'avgPerUser'
  | 'newInvestmentsCount'
  | 'newInvestmentsValue'
  | 'totalInvestmentsToDate'
  | 'currentCumulativeValue';

export const userChartCards: Array<CardProps & { id: UserCardId }> = [
  {
    id: 'newUsers',
    title: 'New users',
    value: '0',
    dollarAmount: false,
    isComingSoon: false,
    type: 'bar',
    strokeColor: '#4361D9',
  },
  {
    id: 'totalUsers',
    title: 'Current total users',
    value: '0',
    delta: '~0 users/30 days',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#16A34A',
  },
  {
    id: 'newVerifiedUsers',
    title: 'New verified users',
    value: '0',
    dollarAmount: false,
    isComingSoon: false,
    type: 'bar',
    strokeColor: '#4361D9',
  },
  {
    id: 'totalVerifiedUsers',
    title: 'Total verified users',
    delta: '~0 users/30 days',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#16A34A',
  },
  {
    id: 'totalUserValue',
    title: 'Current total user value',
    value: '$0',
    delta: '~$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#249CBA',
  },
  {
    id: 'avgPerUser',
    title: 'Current average per user',
    value: '$0',
    delta: '~$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#9F4AFF',
  },
  {
    id: 'newInvestmentsCount',
    title: 'Total number of new investments',
    value: '0',
    delta: '~0 investments/day',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#4361D9',
  },
  {
    id: 'newInvestmentsValue',
    title: 'Total value of new investments',
    value: '$0',
    delta: '~$0/day',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#16A34A',
  },
  {
    id: 'totalInvestmentsToDate',
    title: 'Total investments to date',
    value: '0',
    delta: '+0/30 days',
    dollarAmount: false,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#249CBA',
  },
  {
    id: 'currentCumulativeValue',
    title: 'Current cumulative value',
    value: '$0',
    delta: '+$0/30 days',
    dollarAmount: true,
    isComingSoon: false,
    type: 'line',
    strokeColor: '#9F4AFF',
  },
];

const entitiesChartCards: CardProps[] = [
  {
    title: 'Total new users',
    value: '235',
    delta: '~7.8 users/day',
    dollarAmount: false,
    isComingSoon: true,
    type: 'line',
  },
  {
    title: 'Current total users',
    value: '320',
    delta: '~75 users/30 days',
    dollarAmount: false,
    isComingSoon: true,
    type: 'line',
  },
];

const fundsChartCards: CardProps[] = [
  {
    title: 'Total new users',
    value: '235',
    delta: '~7.8 users/day',
    dollarAmount: false,
    isComingSoon: true,
    type: 'line',
  },
  {
    title: 'Current total users',
    value: '320',
    delta: '~75 users/30 days',
    dollarAmount: false,
    isComingSoon: true,
    type: 'line',
  },
];

export const analyticsData = [
  { title: 'Users Statistics', data: userChartCards },
  { title: 'Entities Statistics', data: entitiesChartCards },
  { title: 'Funds Statistics', data: fundsChartCards },
];
